import { formatMoney } from '@app/shared'
import './balance.css'

/**
 * A balance on a screen, written as `formatBalance` writes it everywhere: the
 * amount, and `CR` after it where the billing account is in credit.
 *
 * `align` is the column's to set, and only where one of its rows is in credit:
 * an owed row then keeps the CR slot's width, unseen, so the figures stay
 * aligned on the decimal. A column of owed balances alone reserves nothing,
 * because a gap after every figure reads as something missing.
 */
export function Balance({ cents, align }: { cents: number; align?: boolean }) {
  const credit = cents < 0
  return (
    <span className="balance">
      {formatMoney(Math.abs(cents))}
      {credit || align ? (
        <span className="balance__cr" data-empty={credit ? undefined : ''}>
          {/* Unseen where it is owed: it holds the width, and is not read. */}
          <span aria-hidden={credit ? undefined : true}>CR</span>
        </span>
      ) : null}
    </span>
  )
}
